import { t } from "../lib/i18n";
import PublicNavbar from './PublicNavbar';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <PublicNavbar />
      <div className="container mx-auto py-10 px-4 max-w-4xl">
      <Link to="/" className="inline-block mt-4 mb-8 bg-indigo-700 text-white font-bold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 no-underline">{t("privacyPolicy.k1")}</Link>
      <h1 className="text-center text-2xl font-bold mb-4">{t("privacyPolicy.k2")}</h1>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k3")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k4")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k5")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k6")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k7")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k8")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k9")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k10")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k11")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k12")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k13")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k14")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k15")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k16")}</h2>
      <div className="bg-indigo-50 border-l-4 border-indigo-600 p-4 mb-6 rounded-r">
        <p className="mb-2 font-semibold text-indigo-950">{t("privacyPolicy.k17")}</p>
        <p className="mb-2 text-text-primary">
          {t("privacyPolicy.k18")} </p>
        <h3 className="font-bold text-md mt-3 mb-1 text-indigo-900">{t("privacyPolicy.k19")}</h3>
        <ol className="list-decimal list-inside mb-3 text-text-primary space-y-1">
          <li>{t("privacyPolicy.k20")} <strong>support@credominion.com</strong> {t("privacyPolicy.k21")} <strong>{t("privacyPolicy.k22")}</strong>.</li>
          <li>{t("privacyPolicy.k23")}</li>
          <li>{t("privacyPolicy.k24")}</li>
        </ol>
        <h3 className="font-bold text-md mt-3 mb-1 text-indigo-900">{t("privacyPolicy.k25")}</h3>
        <ul className="list-disc list-inside mb-3 text-text-primary space-y-1">
          <li>{t("privacyPolicy.k26")}</li>
          <li>{t("privacyPolicy.k27")}</li>
          <li>{t("privacyPolicy.k28")}</li>
        </ul>
        <h3 className="font-bold text-md mt-3 mb-1 text-indigo-900">{t("privacyPolicy.k29")}</h3>
        <p className="text-text-primary text-sm">
          {t("privacyPolicy.k30")} </p>
      </div>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k31")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k32")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k33")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k34")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("privacyPolicy.k35")}</h2>
      <p className="mb-4 text-text-primary">{t("privacyPolicy.k36")}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;